import { memo, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Select } from '@ds';
import { IOption, SelectChangeVariant } from '@ds/elements/Select/Select.types';
import { useUserProfileStore } from 'src/stores/UserProfile';
import { INationality } from 'src/shared/types/Beneficiary';
import styles from './NationalityList.module.scss';

export interface INationalityProps extends IOption {
  isNew?: boolean;
}

const NationalityList: React.FC<{
  refNationalities: INationality[];
  nationalities: INationalityProps[];
  countries: IOption[];
  onUpdate: (list: IOption[]) => void;
}> = ({ refNationalities = [], nationalities: initialNationalities, countries, onUpdate }) => {
  const [nationalities, setNationalities] = useState<INationalityProps[]>(initialNationalities);
  const { editMode } = useUserProfileStore();

  useEffect(() => {
    setNationalities(initialNationalities);
  }, [initialNationalities]);

  const handleRemoveNationality = (value: number) => {
    const list = nationalities.filter((nationality) => nationality.value !== value);
    onUpdate(list);
  };

  const handleAddNationality = (data: IOption | null) => {
    if (data && !nationalities.find((nationality) => nationality.value === data.value)) {
      const list = [
        ...nationalities,
        { ...data, isNew: !refNationalities.find((nationality) => nationality.countryCode == data.value) },
      ];
      onUpdate(list);
    }
  };

  return (
    <div>
      {nationalities.length > 0 && (
        <div className={styles['nationalities-list']}>
          {nationalities.map((nationality) => (
            <div
              key={nationality.value}
              className={classNames(styles['nationality'], {
                [styles['nationality-highlighted']]: nationality.isNew,
                [styles['nationality-disabled']]: !editMode,
              })}
            >
              <p>{nationality.label}</p>
              <div
                className={styles['remove-icon']}
                onClick={() => {
                  if (editMode) handleRemoveNationality(nationality.value as number);
                }}
              ></div>
            </div>
          ))}
        </div>
      )}
      {(editMode || nationalities.length === 0) && (
        <Select
          searchable={true}
          options={countries.filter(
            (country) => !nationalities.some((nationality) => nationality.value === country.value)
          )}
          selectedOption={null}
          onChange={handleAddNationality}
          disabled={!editMode}
          selectChangedStyle={SelectChangeVariant.Secondary}
        />
      )}
    </div>
  );
};

export default memo(NationalityList);
